import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";

export default function Disclaimer() {
  return (
    <LegalLayout
      testid="disclaimer-page"
      eyebrow="Legal"
      title="Disclaimer"
      updated="July 1, 2026"
    >
      <LegalSection title="1. General Information" testid="disclaimer-section-general">
        <p>
          The information provided on this website by UCUBE Technologies is for general
          informational purposes only. All information is provided in good faith; however, we
          make no representation or warranty of any kind, express or implied, regarding the
          accuracy, adequacy, validity, reliability, or completeness of any information on this
          website.
        </p>
      </LegalSection>

      <LegalSection title="2. No Professional Advice" testid="disclaimer-section-advice">
        <p>
          Content on this website, including case studies and service descriptions, does not
          constitute professional, technical, legal, or financial advice. You should seek
          independent advice specific to your circumstances before making any decisions based on
          information found on this website.
        </p>
      </LegalSection>

      <LegalSection title="3. External Links" testid="disclaimer-section-links">
        <p>
          This website may contain links to external websites not provided or maintained by
          UCUBE Technologies. We do not guarantee the accuracy, relevance, or completeness of any
          information on these external websites and are not responsible for their content.
        </p>
      </LegalSection>

      <LegalSection title="4. Limitation of Liability" testid="disclaimer-section-liability">
        <p>
          Under no circumstances shall UCUBE Technologies be liable for any loss or damage of any
          kind incurred as a result of the use of this website or reliance on any information
          provided on it. Your use of this website and your reliance on any information is solely
          at your own risk.
        </p>
      </LegalSection>

      <LegalSection title="5. Contact Us" testid="disclaimer-section-contact">
        <p>
          If you have any questions about this Disclaimer, contact us at{" "}
          <a href="mailto:contactus@ucubetechnologies.com">contactus@ucubetechnologies.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
